import { Component } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import HeaderSistema from "./components/HeaderSistema";
import Pesquisa from "lirida-back-service/Servicos/Pesquisa/Pesquisa";
import Pessoa from "lirida-back-service/Servicos/Pessoa/Pessoa";
import DocumentoService from 'lirida-back-service/Servicos/Documento/DocumentoService';
import Item from "lirida-back-service/Servicos/Item/Item";
import ItemService from "lirida-back-service/Servicos/Item/ItemService";
import Util from "../../util/Util";
import Constante from "../../util/Constante";

export default class Documentos extends Component {
    util = new Util()
    constante = new Constante()
    documentoService = new DocumentoService(this.constante.token, this.constante.url_base)
    itemService = new ItemService(this.constante.token, this.constante.url_base)

    state = {
        pessoaUsuario: new Pessoa(),
        listaItem: [],
        item: new Item(),
        listaDocumentoItem: [],
        filtro: {
            local: '',
            bloco: '',
            item: '',
            dataCadastroInicial: '',
            dataCadastroFinal: '',
            dataProgramadaInicial: '',
            dataProgramadaFinal: '',
            horario: '',
        }
    }

    componentDidMount() {
        this.iniciar()
    }

    async iniciar() {
        let pessoaUsuario = await this.util.buscarLocalStorage("PESSOA_USUARIO");
        this.listar()

        let retornItem = await this.itemService.listar(this.constante.seqUsuario, '')
        let listaItem = retornItem.objeto

        this.setState({
            pessoaUsuario: pessoaUsuario,
            listaItem: listaItem,
        })
    }

    async listar() {
        let listaPesquisa = []
        let filtro = this.state.filtro

        let pesquisa = new Pesquisa();
        pesquisa.campo = 'documento_item.seq_usuario';
        pesquisa.conteudo = this.constante.seqUsuario;
        pesquisa.operacao = '';
        pesquisa.tipo = 'TEXTO';
        listaPesquisa.push(pesquisa);

        pesquisa = new Pesquisa();
        pesquisa.campo = `and documento_item.seq_tipo_documento_processo <> '${this.constante.seqTipoDocumentoProcessoArquivado}'`
        pesquisa.conteudo = this.constante.seqTipoDocumentoProcessoArquivado;
        pesquisa.operacao = 'AND';
        pesquisa.tipo = 'MANUAL';
        listaPesquisa.push(pesquisa);

        if (filtro?.local) {
            pesquisa = new Pesquisa();
            pesquisa.campo = 'documento_item.tags5';
            pesquisa.conteudo = filtro.local;
            pesquisa.operacao = 'AND';
            pesquisa.tipo = 'TEXTO';
            listaPesquisa.push(pesquisa)
        }

        if (filtro?.bloco) {
            pesquisa = new Pesquisa();
            pesquisa.campo = 'documento_item.tags2';
            pesquisa.conteudo = filtro.bloco;
            pesquisa.operacao = 'AND';
            pesquisa.tipo = 'TEXTO';
            listaPesquisa.push(pesquisa)
        }

        if (filtro?.item) {
            pesquisa = new Pesquisa();
            pesquisa.campo = 'documento_item.seq_item';
            pesquisa.conteudo = filtro.item._seqItem;
            pesquisa.operacao = 'AND';
            pesquisa.tipo = 'TEXTO';
            listaPesquisa.push(pesquisa)
        }

        if (filtro?.dataCadastroInicial) {
            pesquisa = new Pesquisa();
            pesquisa.campo = 'documento_item.data_cadastro';
            pesquisa.conteudo = this.util.formatarDataBanco(filtro.dataCadastroInicial);
            pesquisa.operacao = 'AND';
            pesquisa.tipo = 'DATA_INCIAL';
            listaPesquisa.push(pesquisa)
        }

        if (filtro?.dataCadastroFinal) {
            pesquisa = new Pesquisa();
            pesquisa.campo = 'documento_item.data_cadastro';
            pesquisa.conteudo = this.util.formatarDataBanco(filtro.dataCadastroFinal);
            pesquisa.operacao = 'AND';
            pesquisa.tipo = 'DATA_FINAL';
            listaPesquisa.push(pesquisa)
        }

        if (filtro?.dataProgramadaInicial) {
            pesquisa = new Pesquisa();
            pesquisa.campo = 'documento_item.data_programada';
            pesquisa.conteudo = this.util.formatarDataBanco(filtro.dataProgramadaFinal);
            pesquisa.operacao = 'AND';
            pesquisa.tipo = 'DATA_INCIAL';
            listaPesquisa.push(pesquisa)
        }

        if (filtro?.dataProgramadaFinal) {
            pesquisa = new Pesquisa();
            pesquisa.campo = 'documento_item.data_programada';
            pesquisa.conteudo = this.util.formatarDataBanco(filtro.dataProgramadaFinal);
            pesquisa.operacao = 'AND';
            pesquisa.tipo = 'DATA_FINAL';
            listaPesquisa.push(pesquisa)
        }

        console.log(listaPesquisa);

        let retorno = await this.documentoService.listarItemComFiltro(listaPesquisa)
        let listaDocumentoItem = retorno.objeto
        console.log(listaDocumentoItem);

        this.setState({ listaDocumentoItem: listaDocumentoItem })
    }

    render() {
        return (
            <div>
                <HeaderSistema />
                <main style={{ width: "98%", margin: "20px auto" }}>
                    <div
                        style={{
                            border: "1px solid lightgray",
                            padding: 20,
                            borderRadius: 3,
                        }}
                    >
                        <h1 style={{ fontSize: 22, margin: 0 }}>Documentos</h1>
                        <h2 style={{ fontSize: 20, color: 'gray', margin: 0 }}>Documentos</h2>
                    </div>

                    {/* FILTRO */}
                    <div style={{ border: '1px solid lightgray', padding: 10, borderRadius: 3, gap: 20, marginTop: 20 }}>
                        <form onSubmit={pEvento => { pEvento.preventDefault(); this.listar() }}>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 20 }}>
                                <div>
                                    <label>Local</label><br />
                                    <InputText onChange={pTexto => this.setState({
                                        filtro: {
                                            ...this.state.filtro, local: pTexto.target.value
                                        }
                                    })}
                                        style={{
                                            width: "100%",
                                        }}
                                    />
                                </div>

                                <div>
                                    <label>Bloco</label><br />
                                    <InputText onChange={pTexto => this.setState({
                                        filtro: {
                                            ...this.state.filtro, bloco: pTexto.target.value
                                        }
                                    })}
                                        style={{
                                            width: "100%",
                                        }}
                                    />
                                </div>

                                <div>
                                    <label>Item</label><br />
                                    <Dropdown
                                        onChange={pItem => this.setState({
                                            filtro: {
                                                ...this.state.filtro, item: pItem.value
                                            }
                                        })}
                                        options={this.state.listaItem}
                                        optionLabel='nome'
                                        value={this.state.item}
                                        placeholder={this.state.filtro.item.nome || 'selecione'}
                                        style={{
                                            width: "100%",
                                        }}
                                    />
                                </div>
                            </div>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 20, marginTop: 20 }}>
                                <div>
                                    <label>Data cadastro inicial</label><br />
                                    <Calendar
                                        onChange={(pTexto) => this.setState({
                                            filtro: {
                                                ...this.state.filtro, dataCadastroInicial: pTexto.target.value
                                            }
                                        })}
                                        showButtonBar
                                        style={{ width: "100%", height: 40 }}
                                        dateFormat="dd/mm/yy"
                                        placeholder="dd/mm/yyyy"
                                    />
                                </div>

                                <div>
                                    <label>Data cadastro Final</label><br />
                                    <Calendar
                                        onChange={(pTexto) => this.setState({
                                            filtro: {
                                                ...this.state.filtro, dataCadastroFinal: pTexto.target.value
                                            }
                                        })}
                                        showButtonBar
                                        style={{ width: "100%", height: 40 }}
                                        dateFormat="dd/mm/yy"
                                        placeholder="dd/mm/yyyy"
                                    />
                                </div>

                                <div>
                                    <label>Data Programada inicial</label><br />
                                    <Calendar
                                        onChange={(pTexto) => this.setState({
                                            filtro: {
                                                ...this.state.filtro, dataProgramadaInicial: pTexto.target.value
                                            }
                                        })}
                                        showButtonBar
                                        style={{ width: "100%", height: 40 }}
                                        dateFormat="dd/mm/yy"
                                        placeholder="dd/mm/yyyy"
                                    />
                                </div>

                                <div>
                                    <label>Data programada final</label><br />
                                    <Calendar
                                        onChange={(pTexto) => this.setState({
                                            filtro: {
                                                ...this.state.filtro, dataProgramadaFinal: pTexto.target.value
                                            }
                                        })}
                                        showButtonBar
                                        style={{ width: "100%", height: 40 }}
                                        dateFormat="dd/mm/yy"
                                        placeholder="dd/mm/yyyy"
                                    />
                                </div>
                            </div>
                            <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginTop: 15 }}>
                                <Button label="Buscar" className="p-button-raised" type="submit"
                                    style={{ backgroundColor: this.constante.corPrincipal, borderColor: this.constante.corPrincipal }}
                                />
                            </div>
                        </form>
                    </div>
                    {/* FIM FILTRO */}

                    {/* TABELA */}

                    <DataTable
                        showGridlines
                        removableSort
                        paginator
                        responsiveLayout="scroll"
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                        rows={10}
                        rowsPerPageOptions={[50, 60, 70, 80, 100]}
                        style={{ width: "100%", marginTop: 30 }}
                        value={this.state.listaDocumentoItem}
                    >
                        <Column header='Local'
                            field="tags5"
                            sortable
                            body={pItem => <a href={`/sistema/documento_detalhe?id=${pItem._seqDocumentoItem}`}>{pItem.tags5}</a>}
                        />
                        <Column header='Bloco\Sala'
                            field="tags2"
                            sortable
                        />

                        <Column header='Item'
                            field="_itemNome"
                            sortable
                        />

                        <Column header='Status'
                            field="_tipoDocumentoProcessoNome"
                            sortable
                        />

                        <Column header='Data Cadastro'
                            field="dataCadastro"
                            sortable
                            body={pItem => this.util.formatarData(pItem.dataCadastro)}
                        />

                        <Column header='Data Programada'
                            field="dataProgramada"
                            sortable
                            body={pItem => this.util.formatarData(pItem.dataProgramada)}
                        />

                    </DataTable>

                    {/* FIM DA TABELA */}

                </main>
                {/* <Button label="Verificar" onClick={() => console.log(this.state.filtro)} /> */}
            </div>
        )
    }
}